import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router'
import { authChallenge } from '../../redux/actions/authentication'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useQuery } from '../../utils/hooks'
import { connect, ConnectedProps } from 'react-redux'

const NewPassword: React.FC<PropsFromRedux> = ({ authChallenge }) => {
  const form = useForm<{ user: string; pass: string }>()
  const [loading, setLoading] = useState(false)
  const { addAlert } = useSnackBars()
  const history = useHistory()
  const queryParams = useQuery()

  const onFinish = async (values) => {
    const data = {
      challenge: {
        challengeName: 'NEW_PASSWORD_REQUIRED',
        session: queryParams.get('session'),
      },
      userData: {
        username: queryParams.get('username'),
        tenantCode: queryParams.get('tenantCode'),
        newPassword: values.newPassword,
      },
    }
    setLoading(true)
    try {
      const result: any = await authChallenge(data)
      addAlert({ message: result.message, status: 'success' })
      history.push('/dashboard/home/home')
    } catch (err) {
      addAlert({
        message: 'Ha ocurrido un error al intentar cambiar la contraseña.',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="w-96 break-words">
      <h1 className="font-bold text-2xl text-coolGray-900 mb-2">
        Nueva contraseña
      </h1>
      <p className="font-normal text-gray-400 text-sm">
        Por motivos de seguridad, es requerido que ingrese una nueva contraseña.
      </p>
      <Form form={form} classes="mt-8" onSubmit={onFinish}>
        <FormItem
          name="newPassword"
          classes="col-span-12 my-2"
          rules={{ required: 'Ingrese su contraseña' }}
        >
          <InputText label="Contraseña" password />
        </FormItem>
        <FormItem
          name="confirmPassword"
          classes="col-span-12 my-2"
          rules={{ required: 'Ingrese su contraseña' }}
        >
          <InputText label="Confirmar contraseña" password />
        </FormItem>
        <Button
          type="primary"
          classes="col-span-12 mt-6 font-semibold tracking-wide"
          htmlType="submit"
          loading={loading}
        >
          Continuar
        </Button>
      </Form>
    </div>
  )
}

const connector = connect(null, { authChallenge })

export default connector(NewPassword)

type PropsFromRedux = ConnectedProps<typeof connector>
